<template>
  <div id="cashierGoodsDetails">
    <div class="rc-title flex-between">
      <div>规格选择</div>
      <div class="back" @click="back">X</div>
    </div>
    <div class="content-wrap">
      <div class="row borderBottom">
        <div class="goodsImg">
          <img :src="goodsIfm.goodsImage" alt />
        </div>
        <div class="goodsText">
          <div class="goodsName">{{goodsIfm.goodsName}}</div>
          <div>
            商品价格：
            <span class="goodsSprice">￥{{goodsIfm.retailPrice.toFixed(2)}}</span>
          </div>
          <div>商品条码：{{goodsIfm.goodsBarCode}}</div>
          <div>已选："{{goodsIfm.goodsUnit}}"</div>
        </div>
      </div>
      <div class="borderBottom">
        <div>规格</div>
        <div>
          <div class="product">{{goodsIfm.valueContent}}</div>
        </div>
      </div>
      <div>
        <div>单位</div>
        <div class="product2">{{goodsIfm.goodsUnit}}</div>
        <div style="margin-top:20px">购买数量</div>
        <div class="buy">
          <input class="buyInput" @blur="buyNumChange" v-model="buyNumber" />
            <div class="unit">{{goodsIfm.goodsUnit}}</div>
        </div>
      </div>
      <div class="confirm">
        <el-button type="primary" @click="selectGoods">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      goodsIfm: [],
      buyNumber: 1
    };
  },
  created() {
    this.goodsIfm = JSON.parse(this.$route.query.item);
  },
  methods: {
    buyNumChange(e) {
      // if (e.unitType == 2) {
      //   reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // } else if (e.unitType == 1) {
      //   reg = /^[1-9]\d*$/;
      // }
      let reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.buyNumber)) {
        this.$message({
          type: "warning",
          message: "请输入正确数量"
        });
        this.buyNumber = ""
        return;
      }
      this.buyNumber = Math.round(this.buyNumber * 1000) / 1000
    },
    //选择商品 productId
    selectGoods() {
      if (this.buyNumber > 0) {
      } else {
        this.$message({
          type: "warning",
          message: "请输入正确数量"
        });
        return;
      }
      if(!this.goodsIfm.isInfiniteStock &&this.buyNumber >this.goodsIfm.qrcTotalStockCount){
          this.$message({
          type: "warning",
          message: "库存不足"
        });
        return;
      }
      var arr = this.goodsIfm; //选择的商品
      var shoppingTrolley = this.$store.state.cartList;
      var idArr = [];
      var idNum = []; // id下标对应的商品数量
      var istrue = false; //判断选中商品是否存在购物车
      var index = null;
      for (let a of shoppingTrolley) {
        idArr.push(a.productId);
           idNum.push(a.goodsNum);
      }
      for (let i in idArr) {
        if (idArr[i] == arr.productId) {
          istrue = true;
          index = i;
            if (this.goodsIfm.isInfiniteStock == 0 && idNum[i] >= this.goodsIfm.qrcTotalStockCount) {
              this.$message({
                type: "warning",
                message: "购物车选择商品库存不足"
              });
              return;
            }
        } else {
          // istrue = false;
        }
      }
      if (istrue) {
        let newGoodsNum =
          Number(this.buyNumber) + shoppingTrolley[index].goodsNum;
        // this.$set(shoppingTrolley[index], 'purchasingCost', this.purchasingCost)
        this.$set(shoppingTrolley[index], "goodsNum", newGoodsNum);
        this.$store.state.cartList = []; //直接赋值页面不刷新
        this.$store.state.cartList = shoppingTrolley;
      } else {
        arr.goodsNum = Number(this.buyNumber);
        shoppingTrolley.push(arr);
        this.$store.state.cartList = shoppingTrolley;
      }
         if (this.$store.state.offers.type == 2) {
          this.$store.state.offers.type = 0;
          this.$store.state.offers.reducePrice = 0;
        } else if (this.$store.state.offers.type == 3) {
          this.$store.state.offers.type = 0;
           this.$store.state.offers.discountNumber = 0;
        }
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
      // console.log(istrue, index, "111");
      this.buyNumber = 1; //商品详情的进货数量
      this.$router.go(-1); //返回上一页
      // console.log(this.shoppingTrolley);
      // console.log(this.$store.state.cartList);
    },
    back() {
      this.$router.go(-1);
    },
    add() {
      this.$store.state.cartList.push({});
    }
  }
};
</script>
<style scoped>
.buy {
  position: relative;
  width: 136px;
}
.unit {
  position: absolute;
  top: 22px;
  right: 10px;
  color: #999999;
}
.confirm {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
#cashierGoodsDetails {
  height: 100%;
  width: 100%;
}

.buyInput {
  width: 50px;
  padding: 12px 41px;
  margin-top: 10px;
}
.product2 {
  padding: 12px 41px;
  /* background: rgba(30, 148, 234, 1); */
  border: 1px solid rgba(30, 148, 234, 1);
  border-radius: 2px;
  color: rgba(30, 148, 234, 1);
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.product {
  padding: 12px 41px;
  background: rgba(30, 148, 234, 1);
  border: 1px solid rgba(16, 142, 233, 1);
  border-radius: 2px;
  color: #fff;
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.borderBottom {
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
}
.goodsSprice {
  color: #f92323;
}
.goodsName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.goodsText {
  margin-left: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.goodsImg img {
  height: 100px;
  width: 100px;
}
.content-wrap {
  padding: 23px 26px;
  font-size: 14px;
}
.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.rc-title {
 /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierGoodsDetails.vue